import { TabsLayout } from "#layouts";

export const Plan = () => (
	<TabsLayout entity="plan" basePath="/plan" paramName="planID" />
);
